/**
 * Where the access token lives. localStorage so it survives page refresh.
 * Trade-off: vulnerable to XSS — mitigated by CSP and the fact this is an
 * internal tool. Same approach the legacy app used.
 */
const TOKEN_KEY = 'tr_access_token';

export function getToken(): string | null {
  try {
    return localStorage.getItem(TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setToken(token: string): void {
  try {
    localStorage.setItem(TOKEN_KEY, token);
  } catch {
    /* private mode etc — no-op */
  }
}

export function clearToken(): void {
  try {
    localStorage.removeItem(TOKEN_KEY);
  } catch {
    /* no-op */
  }
}
